import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';

type Props = {
  children?: React.ReactNode;
} & React.TableHTMLAttributes<HTMLTableCellElement>;

const UFieldPrefix = ({children, ...props}: Props): React.ReactElement => (
  <StyledFieldPrefix {...props}>{children}</StyledFieldPrefix>
);

export const FieldPrefix = observer(UFieldPrefix);

const StyledFieldPrefix = styled.td`
  grid-area: prefix;
  align-self: center;
`;
